import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Divider } from 'antd';
import { ReactComponent as EdgelIcon } from '../../../../../../assets/icons/edge.svg';
import reject_icon from '../../../../../../assets/icons/reject_icon.png';
import return_icon from '../../../../../../assets/icons/return_icon.png';
import check_icon from '../../../../../../assets/icons/check.svg';

const Graph = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);

  return (
    <>
      <Row gutter={32} className="diagram-container">
        <Col span={24} style={{ paddingBottom: '0rem' }}>
          <Divider className="top" />
        </Col>

        {/* Objection and Rejection row */}
        <Col span={24} className="top-actions-container">
          <div className="top-actions-row">
            <div className="rejection-container">
              <div
                className={
                  (apptrackDetails?.activeTaskName ===
                  'task.name.temporary_rejected' || apptrackDetails?.activeTaskName == 'task.name.final_rejected'
                    ? 'active-reject-node '
                    : '') + 'reject-node-main'
                }
              >
                <img
                  src={reject_icon}
                  alt="Reject Icon"
                  //style={{ marginRight: '5px' }}
                />
                <span>Απόρριψη Ένταξης</span>
              </div>
              <div className="rejection-dashed-vertical-down"></div>
            </div>

            <div className="objection-container">
              <div
                className={
                  (apptrackDetails?.activeTaskName === 'task.name.application_evaluation_before_committee' 
                    || apptrackDetails?.activeTaskName === 'task.name.application_evaluation_by_committee'
                    ? 'active-objection-node '
                    : '') + 'objection-node'
                }
              >
                <div className="objection-circle">
                  <img
                    src={check_icon}
                    alt="Check Icon"
                    className="objection-check-icon"
                  />
                </div>
                <div className="objection-text">
                  <span>Ένσταση</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        {/* Main workflow nodes */}
        <Col span={24} className="main-flow-nodes">
          <div
            className={
              (apptrackDetails?.activeTaskName ===
              'task.name.submit_application'
                ? 'active-completion-node '
                : '') + 'state-node first'
            }
          >
            <span>Σε Επεξεργασία από Προμηθευτή</span>
          </div>

          <EdgelIcon className="edge-svg" />

          <div
            style={{ position: 'relative' }}
            className="middle-node-container"
          >
            <div
              className={
                (apptrackDetails?.activeTaskName ===
                'task.name.audit_application'
                || apptrackDetails?.activeTaskName === 'task.name.application_evaluation_by_auditor'
                  ? 'active-completion-node '
                  : '') + 'state-node second'
              }
            >
              <span>Αξιολόγηση Αίτησης</span>
            </div>

            <div className="return-path">
              <div className="return-dashed-vertical"></div>
              <div className="return-triangle-down"></div>
              <div
                className={
                  ((apptrackDetails?.activeTaskName ===
                  'task.name.return_to_supplier' ||
                  apptrackDetails?.activeTaskName === "task.name.application_returned_to_supplier")
                    ? 'active-return-node '
                    : '') + 'return-node'
                }
              >
                <img
                  style={{ marginLeft: '5px' }}
                  src={return_icon}
                  alt="Return Icon"
                />
                <span>Επιστροφή στον Προμηθευτή</span>
              </div>
            </div>
          </div>

          <EdgelIcon className="edge-svg" />

          <div
            className={
              (apptrackDetails?.activeTaskName ===
              'task.name.accepted'
                ? 'active-completion-node '
                : '') + 'state-node third'
            }
          >
            <span>Ένταξη στο Μητρώο Προμηθευτών</span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Graph;
